
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M22 5a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V7a2 2 0 012-2h12zm0 1H10a1 1 0 00-.993.883L9 7v18a1 1 0 00.883.993L10 26h12a1 1 0 00.993-.883L23 25V7a1 1 0 00-.883-.993L22 6zM9 9h14v1H9V9zm6.46 4a7.165 7.165 0 00-.388 1l-2.909-.001-.045.183a5.206 5.206 0 00-.11.832L12 15.3c0 2.073 1.162 3.7 2.5 3.7.865 0 1.658-.681 2.109-1.723a2.75 2.75 0 001.088.223l-.099-.003c-.507 1.296-1.452 2.241-2.597 2.457L15 23h1.5a.5.5 0 110 1h-4a.5.5 0 110-1H14v-3.046c-1.67-.314-2.915-2.179-2.996-4.422L11 15.3c0-.685.108-1.35.315-1.96a.5.5 0 01.474-.34zm3.927 4.494a1 1 0 011.724 0c.665 1.131 1.075 2.001 1.075 2.57a1.938 1.938 0 01-3.874 0c0-.487.3-1.195.806-2.101zm.862.506c-.462.788-.937 1.721-.937 2.063a.938.938 0 001.874 0c0-.342-.474-1.276-.937-2.063zm-3.348-5.821a1 1 0 011.725 0c.665 1.131 1.074 2 1.074 2.569a1.938 1.938 0 01-3.873 0c0-.487.3-1.194.805-2.1zm.863.506c-.463.787-.937 1.721-.937 2.063a.938.938 0 001.873 0c0-.342-.474-1.276-.936-2.063zM10.75 7a.75.75 0 110 1.5.75.75 0 010-1.5zm2 0a.75.75 0 110 1.5.75.75 0 010-1.5zm6.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm2 0a.75.75 0 110 1.5.75.75 0 010-1.5z"}})])
          )
        }
      }
    